<div class="ws-popup-header">
    <span>{{'Payment Link' | translate}}</span>
    <div class="actions">
        <button (click)="closeClicked()" mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>

<div class="ws-popup-content">
    <div class="ws-popup-body">
        <div class="payment-details">
            <div class="flex space-between">
                <div class="flex align-center bold">{{'Generated Link' | translate}}:</div>
                <div class="flex align-center">
                    {{paymentLink.url | truncate : [35, '...']}}
                    &nbsp;
                    <button (click)="copyLinkToClipboard()" mat-icon-button>
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </div>
            </div>
            <br>
            <div>
                <div class="bold">{{'Payment Details' | translate}}:</div>

                <div class="flex space-between">
                    <div class="flex align-center gray">{{'Customer Name' | translate}}:</div>
                    <div class="flex align-center">{{customerName || ('payments.paymentLink.noContact' | translate)}}</div>
                </div>
                <div class="flex space-between">
                    <div class="flex align-center gray">{{'Amount' | translate}}:</div>
                    <div class="flex align-center">{{(paymentLink.amountCents || 0) / 100 | currency:
                        reservation.paymentCurrency}}
                    </div>
                </div>
            </div>
            <br>
            <div class="flex space-between align-center">
                <div class="flex align-center bold">{{'Status' | translate}}:</div>
                <div class="flex align-center">
                    <span class="ws-chip" [ngClass]="'link-status-' + linkStatus">
                        {{ ('payments.paymentLink.status.' + linkStatus) | translate }}
                    </span>
                </div>
            </div>
            <p *ngIf="linkStatus === 'expired'" class="expired-hint gray">
                {{ 'payments.paymentLink.expiredHint' | translate }}
            </p>
        </div>
    </div>
    <div class="ws-popup-footer">
        <div class="actions-footer-left">
            <ws-button
                *ngIf="canRegenerate"
                [callToActionType]="'tertiary'"
                [disabled]="regenerating"
                (click)="regenerateLink()">
                {{ 'payments.paymentLink.regenerate' | translate }}
            </ws-button>
        </div>
        <div class="actions-footer">
            <ws-actions [callToActionType]="'primary'" [options]="sendActions" [text]="'Send' | translate"
                [disabled]="!canSend" icon="keyboard_arrow_down" (clickOnAction)="onSendActionSelected($event)">
            </ws-actions>
        </div>
    </div>
</div>
